import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ClubServicesService } from 'src/app/shared/services/club-services.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { ManageOrderderService } from 'src/app/shared/services/manage-orderder.service';
@Component({
  selector: 'app-select-restaurant',
  templateUrl: './select-restaurant.component.html',
  styleUrls: ['./select-restaurant.component.scss','../../../modules/dashboard/organization-dash/organization-dash.component.scss']
})
export class SelectRestaurantComponent implements OnInit {

  restaurantListNearBy: any;
  apiResponseReceived: Boolean = false;

  selectForm = this.fb.group({
    check: new FormControl('', [Validators.required]),
  })

  disableRestaurantsNext: boolean = true;

  @Input() selectedRestaurantDetails;
  
  constructor(
    private fb: FormBuilder,
    private modalService: BsModalService,
    private csObj: CommonService,
    private toast: ToastrService,
    private dialogue: MatDialog,
    private router: Router,
    private clubServ: ClubServicesService,
    private spinner: SpinnerVisibilityService,
    private manageOrdersServices: ManageOrderderService,
  ) { }

  ngOnInit(): void {
    this.getRestaurantNearByAPICall();
  }

  getRestaurantNearByAPICall() {
    try {
      this.spinner.show();
      this.clubServ.getRestaurantNearBy().subscribe(
        (res: any) => {
          this.apiResponseReceived = true;
          this.restaurantListNearBy = res.output;
          this.spinner.hide();
          console.log(this.selectForm.value.check, "yyyy");

          if(this.selectedRestaurantDetails){

            let id = this.selectedRestaurantDetails.id;
            this.selectRestaurantData = this.selectedRestaurantDetails.restaurant;

            for(var i of this.restaurantListNearBy){
              if(id == i?._id){
                i['selected']= true;
              }else{
                i['selected']= false;
              }
            }
            // this.disableRestaurantsNext = true;

            for (let val of this.restaurantListNearBy) {
              if (val._id == id) {
                // this.selectForm.value.check = id;
                this.selectForm.get('check').patchValue(id);
                this.checkedVal = true;
                this.disableRestaurantsNext = true;
              }
            }
          }
          // else{
          //   if (this.selectForm.value.check === "" || this.selectForm.value.check == undefined) {
          //     this.disableRestaurantsNext = true
          //   } else {
          //     this.disableRestaurantsNext = false
          //   }
          // }
          

        },
        (err: any) => {
          // this.toast.error("Error on fetching events.");
          this.spinner.hide();
        }
      )
    }
    catch (e) { }
  }

  selectRestaurantData:any;
  checkedVal = false;
  checkRestaurant(e: any,restaurant:any) {
    // var id = e.value;

    // var id = e.target.value;
    var id = e.source.value;
    // debugger;
    this.selectRestaurantData = restaurant;
    for(var i of this.restaurantListNearBy){
      if(id == i?._id){
        i['selected']= true;
        this.checkedVal = true;
        this.disableRestaurantsNext = true;
      }else{
        i['selected']= false;
      }
    }
    // this.selectForm.value.check = id;
    this.selectForm.get('check').patchValue(id);
    // e.target.checked==true
    if(e.checked==true){
      for(var i of this.restaurantListNearBy){
        if(id == i?._id){
          i['selected']= true;  
        }
      }
      this.disableRestaurantsNext = true;
    }else{
      for(var i of this.restaurantListNearBy){
        if(id == i?._id){
          i['selected']= false;  
        }
      }
      this.disableRestaurantsNext = false;
    }
  }

  convertToMiles(data){
    let res = parseInt(data)*0.621371;
    return res
  }

  @Output() eventFormData = new EventEmitter();

  onclicknext() {
    // this.modalRef.hide();
    // this.openModalDel(this.delivary);
    console.log(this.selectForm.value, "eventForm");
    // debugger;
    // this.modalRef.hide();
    // this.openModal(this.selectresturent);
    this.eventFormData.emit({selectForm:this.selectForm.value,selectRestaurantData : this.selectRestaurantData});
  }

  @Output() getRestaurantDetails = new EventEmitter();
  @Output() closeSelectRestaurantPopup = new EventEmitter();

  onclickviewSelectRestro(id: any) {
    this.getRestaurantDetails.emit(id);
  }

  closeSelectRestaurantModal() {
    this.closeSelectRestaurantPopup.emit();
    // this.modalRef.hide();
    // this.openModal(this.ProfilePicCropModal);
  }

}
